<template>
  <div>
    <div
      class="row"
      v-for="detail in reimbursementDetails"
      :key="detail.Id"
    >
      <div
        class="col"
        style="font-weight:bold"
      >
        {{ detail.Payee }} -- {{ detail.ReceiptDate }}<br><img :src="detail.ImageUrl">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportReceipts',
  props: {
    reimbursementDetails: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>
